import './portfolio.css';
import NavigationBar from './NAV/NavigationBar';
import Home from './Home/Home';
import About from './About/About';
import Skills from './skills/Skills';
import Service from './service/Service';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer';
import { DataProvider } from './contextAPI';
const Portfolio = () => {
	return (
		<div>
			<DataProvider>
				<NavigationBar />
				<Home />
				<About />
				<Skills />
				<Service />
			</DataProvider>
			{/* <Contact/> */}
			{/* <Footer/> */}
		</div>
	);
};

export default Portfolio;
